"use strict";

angular.module("models").service("TelematicSyncHistoriesService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("TelematicSyncHistories", ["name"], function (element) {
    return "???";
  }));
}]);